module.exports = __webpack_public_path__ + "media/openhat.a62db465.wav";